var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback, useEffect } from "react";
import { usePrevious } from "@restart/hooks";
import { withPortal } from "../../hoc/withPortal";
import { StyledKebab } from "./Kebab.style";
import ButtonIcon from "../button-icon/ButtonIcon";
import { trapEvent } from "../../utils/EventHelpers";
import { caretPosition, caretWidthDiff } from "../tooltip/Tooltip.style";
import useUniqueId from "../../hooks/useUniqueId";
export const prefixId = "nx-kebab-menu-";
/** DEPRECATED - use WithActionMenu or KebabActionMenu */
export const Kebab = (props) => {
    // don't send tabIndex to the StyledKebab component, ButtonIcon should be the only focusable
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onClick, isVisible, forwardedRef, id, "data-insights": insightsAttr, disabled, tabIndex } = props, rest = __rest(props, ["onClick", "isVisible", "forwardedRef", "id", "data-insights", "disabled", "tabIndex"]);
    const [hasInnerFocus, setHasInnerFocus] = useState(false);
    const previousIsVisible = usePrevious(isVisible);
    const [forceFocusStyle, setForceFocusStyle] = useState(false);
    const kebabId = useUniqueId(prefixId, id);
    useEffect(() => {
        var _a;
        if (forceFocusStyle && previousIsVisible && !isVisible) {
            setForceFocusStyle(false);
            // return focus to the kebab button when the menu is closed
            (_a = document.getElementById(kebabId)) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isVisible, previousIsVisible]);
    const handleButtonFocus = useCallback((focused) => () => {
        setHasInnerFocus(focused);
    }, []);
    return (React.createElement(StyledKebab, Object.assign({ isVisible: isVisible, "data-visible": isVisible, "data-focused": hasInnerFocus }, rest),
        React.createElement(ButtonIcon, { "aria-label": "actions", "aria-haspopup": "menu", "aria-controls": `${id}_actions`, "aria-expanded": isVisible, "data-focused": forceFocusStyle || undefined, disabled: disabled, id: `${kebabId}_button`, "data-insights": insightsAttr && `${insightsAttr}_button`, ref: forwardedRef, iconName: "kebab", variant: "round", onClick: (e) => {
                // set focus ring if it is a keyboard event
                if (e.nativeEvent.key) {
                    setForceFocusStyle(true);
                }
                trapEvent(e);
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }, onFocus: handleButtonFocus(true), onBlur: handleButtonFocus(false) })));
};
export const kebabWithPortal = (tooltipContent) => withPortal(tooltipContent, {
    useFocusTrap: false,
    allowTabNavigation: false,
    alignment: "bottomRight",
    trigger: "click",
    offset: [caretPosition - caretWidthDiff / 2, 8],
})(Kebab);
//# sourceMappingURL=Kebab.js.map